/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

export const lineChartOptionsDashboard = {
  chart: {
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: true,
    },
  },
  title: {
    show: true,
    text: 'Daily Visits',
  },
  download: false,
  tooltip: {
    theme: "dark",
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
  },
  xaxis: {
    type: "time",
    categories: [],
    labels: {
      style: {
        colors: "#c8cfca",
        fontSize: "10px",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      style: {
        colors: "#c8cfca",
        fontSize: "10px",
      },
    },
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
    labels: {
      colors: '#fff', // Set legend text color to white
      align: 'left',
    }, 
  },
  grid: {
    strokeDashArray: 0,
    borderColor: "#EDEDED",
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "vertical",
      shadeIntensity: 0,
      gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
      inverseColors: true,
      opacityFrom: 0.8,
      opacityTo: 0,
      stops: [],
    },
    colors: ["#0075FF", "#9ae17b", "#F79F1F", '#f9ca24'],
    // colors: ['#675500', '#f9ca24', "#ff8b00", "#ffc60b", "#5454c5"]
  },
  colors: ["#0075FF", "#9ae17b", "#F79F1F", '#f9ca24'],
  // colors: ['#675500', '#f9ca24', "#ff8b00", "#ffc60b", "#5454c5"]
};
